import { formatPriceParts } from './formatPriceParts';

interface PriceTextProps {
  amount: number;
  isCurrencyCodeHidden?: boolean;
  showFreeIfZero?: boolean;
  countryCode: string;
  currencyCode: string;
  shouldRoundUp?: boolean;
}

export const getPriceText = ({
  amount,
  countryCode,
  currencyCode,
  isCurrencyCodeHidden,
  showFreeIfZero,
  shouldRoundUp,
}: PriceTextProps) => {
  if (amount === 0 && showFreeIfZero) {
    return 'Free';
  }

  return formatPriceParts(amount, shouldRoundUp, {
    isoCode: countryCode,
    currency: currencyCode,
    isCurrencyCodeHidden,
  });
};
